<div class="mx-auto max-w-2xl space-y-6">
  <app-trial-upgrade />

  <!-- One line for the whole flow: the step you are on, named, with its position. The
       previous version listed both steps as chips, which meant /reserveer/date announced
       "Kies een datum" in the stepper, again as a page heading and a third time as the
       calendar itself. The router owns the step, so neither chip was ever clickable. -->
  <div>
    <p class="text-sm font-medium text-fg-subtle">
      Stap {{ activeStep }} van {{ steps.length }}
    </p>
    <!-- No .page-title accent here: the step bar directly below already is the rule
         under this heading, and the two stacked read as one broken component. -->
    <h1 class="text-2xl font-bold text-fg">
      {{ steps[activeStep - 1].label }}
    </h1>
    <div
      class="mt-3 h-1 overflow-hidden rounded-full bg-surface-raised"
      role="progressbar"
      [attr.aria-valuenow]="activeStep"
      aria-valuemin="1"
      [attr.aria-valuemax]="steps.length"
      [attr.aria-label]="steps[activeStep - 1].label"
    >
      <div
        class="h-full rounded-full bg-brand transition-[width]"
        [style.width.%]="(activeStep / steps.length) * 100"
      ></div>
    </div>
  </div>

  <router-outlet />
</div>
